import Icon from 'components/Icon'
import Select from 'components/Select'
import PrinterContext from 'contexts/PrinterContext'
import lodash from 'lodash'
import React, { useContext, useMemo } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  min-width: 200px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
`

const PrinterSelect = (props) => {
  const {
    printers = {},
    currentPrinter = 0,
    changePrinter,
  } = useContext(PrinterContext)

  // console.log("printers", printers)

  const options = useMemo(() => {
    return lodash.concat(
      { label: i18n.t('placeholder_noprinter', 'Kein Drucker'), value: 0 },
      lodash.map(printers, (value, key) => ({ value: key, label: value })),
    )
  }, [printers])

  if (lodash.isEmpty(options)) {
    return null
  }

  return (
    <Wrapper className="ml-2">
      <div className="flex-fill" style={{ color: 'black' }}>
        <Select
          // customDropdownIndicator
          options={options}
          direct
          placeholder={i18n.t('placeholder_noprinter', 'Kein Drucker')}
          isClearable={false}
          value={currentPrinter}
          onChange={changePrinter}
          valuePrefix={
            <span>
              <Icon icon="fas fa-print" className="pr-2 atext-muted" />
              &nbsp;&nbsp;
            </span>
          }
        />
      </div>
    </Wrapper>
  )
}

export default PrinterSelect
